const DAY_NAMES = {
  1: 'Mon',
  2: 'Tue',
  3: 'Wed',
  4: 'Thu',
  5: 'Fri',
  6: 'Sat',
  7: 'Sun',
};

const nthLabel = (nth) => {
  const n = Number(nth || 0);
  if (n === 1) return '1st';
  if (n === 2) return '2nd';
  if (n === 3) return '3rd';
  return `${n}th`;
};

const endSummary = (end) => {
  const type = String(end?.type || 'never').toLowerCase();

  if (type === 'end_date' && end?.end_date) {
    return `until ${end.end_date}`;
  }

  if (type === 'after_occurrences' && end?.occurrences) {
    return `for ${end.occurrences} occurrences`;
  }

  return 'with no end date';
};

export default function recurrenceSummary(schedule = {}) {
  const mode = String(schedule?.send_mode || 'once').toLowerCase();
  const timezone = schedule?.timezone || 'Asia/Riyadh';

  if (mode === 'now') {
    return `Send immediately (${timezone})`;
  }

  if (mode === 'once') {
    return schedule?.send_at
      ? `One-time on ${schedule.send_at} (${timezone})`
      : `One-time schedule (${timezone})`;
  }

  const recurrence = schedule?.recurrence || {};
  const frequency = String(recurrence?.frequency || '').toLowerCase();
  const interval = Number(recurrence?.interval || 1);
  const end = endSummary(recurrence?.end);

  if (frequency === 'daily') {
    return `Every ${interval} day(s), ${end}`;
  }

  if (frequency === 'weekly') {
    const weekdays = Array.isArray(recurrence?.weekdays)
      ? recurrence.weekdays.map((d) => DAY_NAMES[Number(d)]).filter(Boolean)
      : [];

    return `Every ${interval} week(s) on ${weekdays.join(', ') || 'selected days'}, ${end}`;
  }

  if (frequency === 'monthly') {
    const monthlyMode = String(recurrence?.mode || 'day_of_month').toLowerCase();

    if (monthlyMode === 'nth_weekday') {
      const weekday = DAY_NAMES[Number(recurrence?.weekday)] || 'day';
      return `Every ${interval} month(s) on the ${nthLabel(recurrence?.nth)} ${weekday}, ${end}`;
    }

    return `Every ${interval} month(s) on day ${Number(recurrence?.day || 1)}, ${end}`;
  }

  return `Recurring schedule (${timezone})`;
}
